<template>
  <template v-if="arrayValues.length">
    <div v-for="(arrayValue, arrayIndex) in arrayValues" :key="arrayIndex">
      <span v-if="arrayValue">
        {{ t(`enums.${arrayValue.toUpperCase()}`) }}
      </span>
    </div>
  </template>
</template>

<script setup lang="ts">
/***
 * template to show array of enums
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { PaginatedDataTableCellProps } from './templateTypes';
const { t } = useI18n();
const props = defineProps<PaginatedDataTableCellProps>();
const { cell } = props;

// Ensure we always work with an array, even if a single string was passed
const arrayValues = computed(() => {
  return Array.isArray(cell) ? cell : [cell];
});
</script>
